var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-instagramfeed" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.feed
      ? _c(
          "div",
          {
            staticClass: "c-instagramfeed__grid",
            class: "c-instagramfeed__grid--" + _vm.gridSize
          },
          [
            _vm._l(_vm.gridSize, function(index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "c-instagramfeed__post",
                  style: {
                    backgroundImage: "url(" + _vm.postImage(index) + ")"
                  },
                  attrs: {
                    href: _vm.postLink(index),
                    target: "_blank",
                    rel: "noreferrer",
                    alt: "Instagram post fra d. " + _vm.postDate(index)
                  }
                },
                [
                  _vm._v(
                    "\n            Instagram post fra d. " +
                      _vm._s(_vm.postDate(index)) +
                      "\n        "
                  )
                ]
              )
            }),
            _vm._v(" "),
            !_vm.feed
              ? _c("div", { staticClass: "c-instagramfeed__placeholder" })
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.feed
      ? _c(
          "div",
          {
            staticClass: "c-instagramfeed__grid",
            class: "c-instagramfeed__grid--" + _vm.gridSize
          },
          [_c("div", { staticClass: "c-instagramfeed__placeholder" })]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-instagramfeed__heading" }, [
      _c("h2", [_vm._v("#minifabrikken")]),
      _vm._v(" "),
      _c("div", { staticClass: "subheading" }, [
        _c(
          "a",
          {
            attrs: {
              alt: "Minifabrikken Instagram",
              rel: "noreferrer",
              href: "https://www.instagram.com/minifabrikken",
              target: "_blank"
            }
          },
          [_vm._v("@minifabrikken")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }